<template>
  <div id="entrain" class="rdiv entrain">
    <!--header-->
    <div class="box header_onsite">
      <Header @to-login="toLoginPage" :user="user" :token="token" :txt="headerTxt" @to-logout="toLogout" @to-reg="toReg" @to-record="toRecord"></Header>
      <div class="clear"></div>
      <div class="onsite_menu">
        <div class="wrap w1200">
          <div class="col_1 menu_r">
            <router-link :to="'/entrain/home'" active-class="focus">首页</router-link>
            <router-link :to="'/entrain/courseList'" active-class="focus" :class="{'focus': subIsActive('/entrain/courseList')}">线上课程</router-link>
            <router-link :to="'/entrain/livePlayList'" active-class="focus" :class="{'focus': subIsActive('/entrain/liveplayList')}">直播课程</router-link>
            <router-link :to="'/entrain/planList'" active-class="focus" :class="{'focus': subIsActive('/entrain/planList')}">培训计划</router-link>
            <router-link :to="'/entrain/enrollList'" active-class="focus" :class="{'focus': subIsActive('/entrain/enrollList')}">报名信息</router-link>
            <router-link :to="'/entrain/taskList'" active-class="focus" :class="{'focus': subIsActive('/entrain/taskList')}" v-if="token">任务中心</router-link>
          </div>
          <!--div class="col_2 w200">
            <input name="" type="button" class="search_bt_entrain" /><input name="" class="search_put_entrain" type="text" placeholder="输入关键字搜索" />
          </div-->
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!--/header-->
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
  import Header from '@/components/entrain/header/header.vue'
  import Footer from '@/components/byl/footer/footer.vue'
  import utils from '@/utils'
  import { mapState, mapActions } from 'vuex'

export default {
  components: { Header, Footer },
  data () {
    return {
      headerTxt: '管理企业',
      currentActivePath: ''
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token'])
  },
  created () {
  },
  mounted () {
    if (this.$route.meta.navClass) { // 应付刷新
      this.currentActivePath = this.$route.meta.navClass
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.currentActivePath = val.meta.navClass
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    ...mapActions('auth', {
      logout: 'logout'
    }),
    subIsActive (input) {
      return this.currentActivePath == input
    },
    toLoginPage () {
      // this.$router.push('/byl/login')
      var domain = utils.getQueryString('domain')
      var back_route = window.location.hash.split('?')[0]
      window.location.href = window.location.origin + '/#/byl/login?h=' + back_route + '&domain=' + domain
    },
    toLogout () {
      if (this.user) {
        this.logout()
      }
    },
    toReg () {
      var domain = utils.getQueryString('domain')
      var back_route = window.location.hash.split('?')[0]
      window.location.href = window.location.origin + '/#/byl/orgreg?h=' + back_route + '&domain=' + domain
    },
    toRecord () {
      this.$router.push('/entrain/org')
    }
  }
}
</script>
<style lang="scss">
  #entrain .study_detail_top { margin-top: 121px; }
</style>



// WEBPACK FOOTER //
// src/page/entrain/index.vue